import { LoopCircleLoading } from "react-loadingg";
export default function LoaderCustom({ size = "large" }) {
  return <LoopCircleLoading color={"red"} size={size} />;
}
